<template>
    <div class="content">
        <div class="content-head" v-if="showQuery">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="办事处" v-if="isFiltration">
                    <el-select v-model="params.RegionalID" placeholder="请选择大区" class="el-select-medium" @change="onSelectdata">
                        <el-option label="请选择大区" :value="0"></el-option>
                        <el-option v-for="item in regionoptions" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                    </el-select>
                    <el-select v-model="params.BranceOfficeCode" placeholder="请选择办事处" class="el-select-medium" style="margin-left: 5px">
                        <el-option label="请选择办事处" value=""></el-option>
                        <el-option v-for="item in officeoptions" :key="item.ID" :label="item.Name" :value="item.Name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务员">
                    <el-input autocomplete="on" name="BranceOfficeMemerCode" v-model="params.BranceOfficeMemerCode" placeholder="请输入业务员编号、名称" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="ERP订单号">
                    <el-input autocomplete="on" name="ERPOrderSN" v-model="params.ERPOrderSN" placeholder="请输入ERP订单号" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="订单类型">
                    <el-select v-model="params.OrderType" placeholder="请选择" class="el-select-medium" clearable>
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="订单号">
                    <el-input autocomplete="on" name="OrderSN" v-model="params.OrderSN" placeholder="请输入订单号" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="工程名称">
                    <el-input autocomplete="on" name="ProjectName" v-model="params.ProjectName" placeholder="请输入工程名称" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="BPM审核状态">
                    <el-select v-model="params.BPMState" placeholder="请选择" class="el-select-medium" clearable style="width: 120px">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核状态">
                    <el-select v-model="params.State" placeholder="请选择" class="el-select-medium" clearable style="width: 120px">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建日期" v-if="isFiltration">
                    <el-date-picker v-model="params.CreateBeginDate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.CreateEndDate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="异常状态" v-if="isFiltration">
                    <el-select v-model="params.DistributeMain_IsInvalid" placeholder="请选择" class="el-select-medium" clearable>
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getTableList(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title" v-if="showQuery"> 
                业务划分规则管理列表
                <span>
                    <el-button type="primary" @click="openAppend(1)" icon="el-icon-plus">新增</el-button>

                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button>
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getExport()">导出查询信息(最多5000条)</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="tableData" :height="maxheight" ref="multipleTable" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">

                <el-table-column prop="DistributeMain_ERPOrderSN" label="ERP订单号" width="110"  show-overflow-tooltipalign="center"></el-table-column>
                <el-table-column prop="DistributeMain_OrdersSN" label="订单号" width="110" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="DistributeMain_ProjectName" label="工程名称" align="left" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="DistributeMain_OrdersOfficeManName" label="业务员" show-overflow-tooltip width="100" align="center"></el-table-column>
                <el-table-column prop="DistributeMain_OrdersOfficeCode" label="办事处" show-overflow-tooltip width="100" align="center"></el-table-column>
                <el-table-column prop="DistributeMain_OrderTypeName" label="订单类型" show-overflow-tooltip align="center" width="100"></el-table-column>
                <el-table-column prop="DistributeMain_BPMStatusName" label="BPM审核状态" show-overflow-tooltip width="100" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.DistributeMain_BPMStatusName)">{{ scope.row.DistributeMain_BPMStatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DistributeMain_StatusName" label="审核状态" show-overflow-tooltip width="100" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.DistributeMain_StatusName)">{{ scope.row.DistributeMain_StatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DistributeMain_IsInvalidName" label="异常状态" show-overflow-tooltip width="100" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.DistributeMain_IsInvalidName)">{{ scope.row.DistributeMain_IsInvalidName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DistributeMain_AddTime" label="创建时间" show-overflow-tooltip width="150" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.DistributeMain_AddTime | formatDates }}
                    </template>
                </el-table-column>
                <el-table-column prop="Orders_SN" label="计算区间" width="200" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.DistributeMain_ValidStartDate | formatDate }}-{{ scope.row.DistributeMain_ValidEndDate | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleViewsDetail(scope.row)">查看</span>
                            <span v-if="scope.row.EditState == 'true' || scope.row.EditTip == 'true'" class="operation-bar-block" @click="openAppend(2, scope.row)">编辑</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <manageDetails :isdetailFlag="isdetailFlag" @handleClose="handleClose" :id="id" />
        <append :isAppendAdd="isAppendAdd" @onClose="onClose" :status="type" :id="id" />
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import manageDetails from './components/manageDetails.vue';
import append from './components/append.vue';
import { formatDate, downloadFile } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
export default {
    name: 'performanceDivision',
    mixins: [myMixin],
    components: {
        Pagination,
        manageDetails,
        append
    },
    props: {
        showQuery: {
            type: Boolean,
            default: true
        },
        projectName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isdetailFlag: false,
            isAppendAdd: false,
            loadingBtn: false,
            id: 0,
            type: 1,
            params: {
                RegionalID: 0,
                BranceOfficeCode: '',
                BranceOfficeMemerCode: '',
                ERPOrderSN: '',
                OrderSN: '',
                OrderType: '',
                ProjectName: this.showQuery?'':this.projectName,
                BPMState: '',
                State: '',
                CreateBeginDate: '',
                CreateEndDate: '',
                DistributeMain_IsInvalid: ''
            },
            tableData: [],
            officeoptions: [],
            regionoptions: [],
            options: [
                { value: 0, label: '线下' },
                { value: 1, label: '商城' },
                { value: 2, label: '代客下单' }
            ],
            options1: [
                { value: 0, label: '待送审' },
                { value: 1, label: '审核中' },
                { value: 2, label: '已通过' },
                { value: 3, label: '未通过' },
                { value: -1, label: '送审失败' }
            ],
            options2: [
                { value: 0, label: '待送审' },
                { value: 1, label: '已通过' },
                { value: 2, label: '未通过' }
            ],
            options3: [
                { value: 0, label: '正常' },
                { value: 1, label: '异常' }
            ]
        };
    },
    mounted() {
        this.getLargeRegions();
        this.getBranchOffices();
        this.getTableList();
    },
    methods: {
        onRefresh() {
            this.params = {
                RegionalID: 0,
                BranceOfficeCode: '',
                BranceOfficeMemerCode: '',
                ERPOrderSN: '',
                OrderSN: '',
                Distribute_OrderType: '',
                ProjectName: '',
                BPMState: '',
                State: '',
                startDate: '',
                endDate: '',
                DistributeMain_IsInvalid: ''
            };
            this.officeoptions = [];
            this.regionoptions = [];
            this.getLargeRegions();
            this.getBranchOffices();
            this.getTableList(true);
        },
        getTableList(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getOrdersPerformanceDistributeMainsGroup(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.tableData.map((item) => {
                            item.DistributeMain_ValidStartDate = formatDate(item.DistributeMain_ValidStartDate, true);
                            item.DistributeMain_ValidEndDate = formatDate(item.DistributeMain_ValidEndDate, true);
                            item.DistributeMain_AddTime = item.DistributeMain_AddTime;
                        });
                        this.paginationOptions.total = res.data.RecordCount;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = { ...this.params };
            return { json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        getExport() {
            this.$newsApi.GetOrdersPerformanceDistributeMainsGroupExport(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },
        openAppend(type, row) {
            console.log(type, row);
            this.type = type;
            if (this.type == 2) {
                this.id = row.DistributeMain_ID;
            }
            this.isAppendAdd = true;
        },

        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getTableList();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getTableList();
        },
        onSelectdata(e) {
            console.log(e, 'eeeeeeeee');
            this.params.BranceOfficeCode = '';
            this.getBranchOffices();
        },
        //获取全部大区
        getLargeRegions() {
            this.$newsApi.common.getLargeRegions().then((res) => {
                if (res.data.Resultcode == 0 && res.data.data) {
                    this.regionoptions = res.data.data;
                }
            });
        },
        //获取根据大区获取办事处列表
        getBranchOffices() {
            this.$newsApi.common.getBranchOffices({ RegionalID: this.params.RegionalID }).then((res) => {
                if (res.data.Resultcode == 0 && res.data.data) {
                    this.officeoptions = res.data.data;
                }
            });
        },
        handleViewsDetail(row) {
            this.isdetailFlag = true;
            this.id = row.DistributeMain_ID;
            console.log(row);
        },
        handleClose() {
            this.isdetailFlag = false;
        },
        onClose(flag) {
            if (flag) {
                this.onRefresh();
            }
            this.isAppendAdd = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>